import {Button} from '@mui/material';
import {QuestionStatus} from '@cp/model';
import {env} from '../../config/env';

export interface ButtonQuestionStatusProps {
  status: QuestionStatus;
  isCurrentStatus: boolean;
  isNextStep: boolean;
  loading: boolean;
  onClick: () => void;
}

export default function ButtonQuestionStatus({
  status,
  isCurrentStatus,
  isNextStep,
  loading,
  onClick,
}: ButtonQuestionStatusProps) {
  const statusConfig = env.question.status[status];

  return (
    <Button
      variant={isNextStep ? 'contained' : 'outlined'}
      onClick={onClick}
      disabled={loading || isCurrentStatus}
      sx={{
        borderColor: statusConfig?.color,
        bgcolor: isNextStep ? statusConfig?.color : 'transparent',
        color: isNextStep ? 'white' : statusConfig?.color,
        '&:hover': {
          bgcolor: isNextStep ? statusConfig?.color : 'transparent',
          borderColor: statusConfig?.color,
          opacity: isNextStep ? 0.9 : 0.7,
        },
        '&:disabled': {
          borderColor: statusConfig?.color,
          color: statusConfig?.color,
          opacity: 0.5,
        },
      }}
    >
      {isCurrentStatus ? `Current: ${statusConfig?.label}` : statusConfig?.label}
    </Button>
  );
}
